export const isDetailDamaged = (damagesList, detailsList, damage_code) => {
	const damage =
		detailsList?.find((damage) => damage === damage_code) ||
		damagesList?.find((damage) => damage?.parts === damage_code) ||
		damagesList?.find((damage) => damage?.placement?.find((placement) => placement?.parts === damage_code));

	return damage ? true : false;
};
